import { render, staticRenderFns } from "./BuildingsMapView.vue?vue&type=template&id=f8910d5c&scoped=true"
import script from "./BuildingsMapView.vue?vue&type=script&lang=js"
export * from "./BuildingsMapView.vue?vue&type=script&lang=js"
import style0 from "./BuildingsMapView.vue?vue&type=style&index=0&id=f8910d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8910d5c",
  null
  
)

export default component.exports